import React, { Component } from 'react';
import _ from 'lodash';

import { authUserState } from '../stores/common';

import { CheckListReportWidget, CheckListWidget, TaskListWidget } from './CheckList';
import { ReleaseWidget } from './Release';
import { TransferWidget } from './Transfers';
import { checkRights } from '../functions';
import { ContentWidget } from './Content';

export class DashboardPage extends Component {
	render() {
		var widgets = !_.isUndefined(authUserState.Dashboards) ? _.map(authUserState.Dashboards.Widget, "Group") : [];

		return (
			<div className="page" id="DashboardPage">
				<div className="head"><h2>Рабочий стол</h2></div>
				<section>
					{_.map(widgets, function(item) {
						if (item === "CheckList") return <TaskListWidget key={item} />
						if (item === "Release") return <ReleaseWidget key={item} />
						if (item === "Movement") return <TransferWidget key={item} />
						if (item === "News") return <ContentWidget key={item} />
					})}
					{/* {_.indexOf(availableWidgets, "CheckList") > -1 && <TaskListWidget /> } */}
					{/* {_.indexOf(availableWidgets, "Release") > -1 && <ReleaseWidget /> } */}
					{/* <TaskListWidget key={"CheckList"} /> */}
								{/* < key={"Release"} /> */}
{/* <TransferWidget key={"Movement"} /> */}
					{authUserState.HasCheckList && !authUserState.HasERP && checkRights("ReportCheckList") &&
						<CheckListReportWidget key="CheckListrep" />
					}
					{authUserState.HasCheckList && !authUserState.HasERP && checkRights("ManageCheckList") &&
						<CheckListWidget key="CheckListset" />
					}
				</section>
			</div>
		)
	}
}